import axios from "axios";
import { axiosInstance } from "..";
import { API_BASE_URL, APP_VERSION } from "config_environment";
import { LocalStorageKey } from "utils";

// Use production.ugenie.io for notifications only if current API is api.ugenie.io, FIX SOON THIS WEEK mon 5th jan week
const PRODUCTION_API_URL = "https://production.ugenie.io/api/v1";
const shouldUseProductionForNotifications = API_BASE_URL.includes("api.ugenie.io");

const notificationAxios = axios.create({
	baseURL: shouldUseProductionForNotifications ? PRODUCTION_API_URL : API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
		"X-UHUBS-PLATFORM": "web",
		"X-UHUBS-PLATFORM-VERSION": APP_VERSION,
	},
});

// Add auth token interceptor
notificationAxios.interceptors.request.use((config) => {
	const token = localStorage.getItem(LocalStorageKey);
	if (token && config.headers) {
		config.headers["Authorization"] = token;
	}
	return config;
});

const getNotificationInstance = () =>
	shouldUseProductionForNotifications ? notificationAxios : axiosInstance();

export const userNotifications = {
	getSettings: (payload: { communityId: number }) =>
		getNotificationInstance().get(
			`/communities/${payload.communityId}/notifications/settings/edit`,
		),
	toggle: (payload: { communityId: number; membership: any }) =>
		getNotificationInstance().patch(
			`/communities/${payload.communityId}/notifications/settings`,
			{
				membership: payload.membership,
			},
		),
	getNotifications: (payload: { page: number; communityId: number }) =>
		getNotificationInstance().get(
			`/communities/${payload.communityId}/notifications`,
			{
				params: {
					page: payload.page,
				},
			},
		),
	openNotification: (communityId: number, notificationId: number) =>
		getNotificationInstance().get(
			`/communities/${communityId}/notifications/${notificationId}`,
		),

	markAllAsRead: (communityId: number) =>
		getNotificationInstance().put(
			`/communities/${communityId}/notifications/mark_all_as_read`,
		),
};
